module.exports = __webpack_public_path__ + "static/media/step-1_graphic.07a4bf75.svg";